import brain from './brain.png';
import colon from './colon.png';
import hip from './hip.png';
import kidney from './kidney.png';
import knee from './knee.png';
import piles from './piles.png';
import spine from './spine.png';
import stomach from './stomach.png';

export default { brain, colon, hip, kidney, knee, piles, spine, stomach };
